import { useEffect } from 'react';
import { scrollTop } from '../../helpers/scrollTop';
import './TermsOfService.scss';

export const TermsOfServiceCOM = () => {
  useEffect(() => {
    scrollTop();
  });

  return (
    <section className="terms">
      <div className="_container terms__container">
        <h1 className="terms__title title">Terms of Service</h1>
        <div>
          <p>
            <strong>SIXTIX Privacy Policy</strong>
          </p>
          <p> </p>
          <p>
            <strong>Last Updated: 01-11-2024</strong>
          </p>
          <p> </p>
          <p>
            <strong>Introduction</strong>
          </p>
          <p> </p>
          <p>
            This Privacy Policy explains how SIXTIX doo. (&quot;SIXTIX&quot;,
            &quot;we&quot;, &quot;us&quot;) collects, uses, shares, and protects
            your personal data in compliance with the General Data Protection
            Regulation (GDPR) and other relevant European data protection laws.
            This policy applies to all users of our website, services, and
            applications.
          </p>
          <p> </p>
          <p>
            <strong>1. Who We Are</strong>
          </p>
          <p> </p>
          <p>
            SIXTIX trade name of SIXTIX doo., located at Humska 1, 11000,
            Beograd (Savski Venac), Serbia, responsible for collecting and
            processing your personal data. SIXTIX is an international ticketing
            company operating across multiple countries, including the
            Netherlands, Serbia, Croatia, Roemania, France, Spain, Italy,
            Belgium, Germany and Austria.
          </p>
          <p>
            For any inquiries regarding the use of your personal data, you can
            reach our Data Protection Officer at{' '}
            <a href="mailto:support@sixtix.com">support@sixtix.com</a> .
          </p>
          <p> </p>
          <p>
            <strong>2. When Does This Privacy Policy Apply?</strong>
          </p>
          <p> </p>
          <p>
            This Privacy Policy applies to the personal data collected when you:
          </p>
          <p>• Visit our website or use our mobile application.</p>
          <p>• Purchase tickets through SIXTIX.</p>
          <p>• Contact our customer support team.</p>
          <p>• Interact with us through social media or email.</p>
          <p> </p>
          <p>
            <strong>3. What Data Do We Collect and How?</strong>
          </p>
          <p> </p>
          <p>We collect various types of personal data, including:</p>
          <p>
            • <strong>Identity and Contact Data</strong>: Name, address, email,
            phone number, date of birth.
          </p>
          <p>
            • <strong>Transaction Data</strong>: Ticket details, event
            preferences, payment details.
          </p>
          <p>
            • <strong>Website Use Data</strong>: IP address, device information,
            and browsing behavior collected via cookies and similar
            technologies.
          </p>
          <p>
            • <strong>Customer Support Data</strong>: Records of communication
            (emails, social media messages, phone calls).
          </p>
          <p>
            • <strong>Social Media Data</strong>: Information shared with us via
            linked accounts (e.g., Facebook, Google).
          </p>
          <p> </p>
          <p>
            <strong>4. How We Use Your Data</strong>
          </p>
          <p> </p>
          <p>We use your personal data for the following purposes:</p>
          <p>
            • <strong>Service Delivery</strong>: To provide ticketing services,
            including booking tickets and handling payments.
          </p>
          <p>
            • <strong>Customer Support</strong>: To assist with your inquiries
            or issues.
          </p>
          <p>
            • <strong>Marketing</strong>: To send you promotional offers
            tailored to your preferences, subject to your consent.
          </p>
          <p>
            • <strong>Fraud Prevention</strong>: To protect against unauthorized
            or fraudulent transactions.
          </p>
          <p>
            • <strong>Compliance</strong>: To fulfill our legal obligations
            under applicable laws and regulations.
          </p>
          <p> </p>
          <p>
            <strong>5. Legal Basis for Processing Your Data</strong>
          </p>
          <p> </p>
          <p>We process your personal data based on:</p>
          <p>
            • <strong>Performance of a Contract</strong>: To provide our
            services as per your agreement with us.
          </p>
          <p>
            • <strong>Legal Obligations</strong>: To comply with tax laws and
            other regulatory requirements.
          </p>
          <p>
            • <strong>Legitimate Interest</strong>: To improve our services,
            enhance user experience, and market products (with opt-out options).
          </p>
          <p>
            • <strong>Consent</strong>: For processing sensitive data or sending
            direct marketing messages (you can withdraw consent at any time).
          </p>
          <p> </p>
          <p>
            <strong>6. Sharing Your Data</strong>
          </p>
          <p> </p>
          <p>We share your data with:</p>
          <p>
            • <strong>Service Providers</strong>: Payment processors, IT
            support, and marketing agencies.
          </p>
          <p>
            • <strong>Event Organizers</strong>: To facilitate your access to
            events.
          </p>
          <p>
            • <strong>Legal Authorities</strong>: When required by law or in
            response to legal processes.
          </p>
          <p> </p>
          <p>
            <strong>7. International Data Transfers</strong>
          </p>
          <p> </p>
          <p>
            Your data may be transferred to partners outside of the European
            Economic Area (EEA). We ensure appropriate safeguards, such as EU
            Standard Contractual Clauses, are in place.
          </p>
          <p> </p>
          <p>
            <strong>8. Data Security</strong>
          </p>
          <p> </p>
          <p>
            We have implemented robust technical and organizational measures to
            protect your data against unauthorized access, alteration, or
            deletion. We regularly review our security practices to ensure your
            data remains secure.
          </p>
          <p> </p>
          <p>
            <strong>9. Data Retention</strong>
          </p>
          <p> </p>
          <p>
            We retain your personal data only for as long as necessary for the
            purposes outlined above or as required by law. Generally, we keep
            your data for up to 2 years after your last interaction with us.
          </p>
          <p> </p>
          <p>
            <strong>10. Your Rights</strong>
          </p>
          <p> </p>
          <p>You have the right to:</p>
          <p>
            • <strong>Access</strong> your data.
          </p>
          <p>
            • <strong>Correct</strong> inaccurate data.
          </p>
          <p>
            • <strong>Delete</strong> data (right to be forgotten).
          </p>
          <p>
            • <strong>Restrict Processing</strong> of your data.
          </p>
          <p>
            • <strong>Port</strong> your data to another provider.
          </p>
          <p>
            • <strong>Object</strong> to data processing for direct marketing.
          </p>
          <p>
            To exercise these rights, contact us at{' '}
            <a href="mailto:support@sixtix.com">support@sixtix.com</a> .
          </p>
          <p> </p>
          <p>
            <strong>11. Changes to This Privacy Policy</strong>
          </p>
          <p> </p>
          <p>
            We may update this Privacy Policy from time to time. Changes will be
            posted on this page, and we will notify you of significant updates
            via email.
          </p>
          <p>‍</p>
        </div>
      </div>
    </section>
  );
};
